import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=477dc03b&scoped=true"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"
import style0 from "./ActionMenu.vue?vue&type=style&index=0&id=477dc03b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477dc03b",
  null
  
)

export default component.exports